import React from 'react'
import { WhenModelValue } from '@morningtrain/react-resources'
import PropTypes from 'prop-types'
import { AngrySmiley, GoodSmiley, Smiley, StraightFace } from 'ui/icons/smileys'
import * as Displays from 'support/displays'

export function CheckupSmiley (props) {
  const {
    name,
    onClick = () => {},
    className = ''
  } = props

  const classList = [
    'w-8', 'h-8',
    className
  ].join(' ')

  return (
    <span className={classList} onClick={onClick}>
      <WhenModelValue name={name} condition='good-smiley'>
        <GoodSmiley
          fill='#FFFFFF'
          className='inline w-8 h-8 mr-2 rounded-full p-1 bg-available'
        />
      </WhenModelValue>
      <WhenModelValue name={name} condition='smiley'>
        <Smiley
          fill='#FFFFFF'
          className='inline w-8 h-8 mr-2 rounded-full p-1 bg-available'
        />
      </WhenModelValue>
      <WhenModelValue name={name} condition='straight-face'>
        <StraightFace
          fill='#FFFFFF'
          className='inline w-8 h-8 mr-2 rounded-full p-1 bg-yellow-400'
        />
      </WhenModelValue>
      <WhenModelValue name={name} condition='angry-smiley'>
        <AngrySmiley
          fill='#FFFFFF'
          className='inline w-8 h-8 mr-2 rounded-full p-1 bg-error'
        />
      </WhenModelValue>
      <Displays.Text name='latest_checkup_label' />
    </span>
  )
}

CheckupSmiley.propTypes = {
  name: PropTypes.string
}

export default CheckupSmiley
